// $0-cost, 100% client-side ROBBED remix engine. Config-driven so new styles are easy to add later.
// Each style: { id, name, tagline, defaults, filter(o), overlay(ctx,W,H,o) }. No AI, no external calls.

const rand = (seed) => { let s = seed % 2147483647; if (s <= 0) s += 2147483646; return () => (s = (s * 16807) % 2147483647) / 2147483647; };

const drawGlitch = (ctx, W, H, amount) => {
  if (amount <= 0) return;
  const r = rand(1234);
  const bands = Math.round(4 + amount * 16);
  const src = ctx.getImageData(0, 0, W, H);
  const tmp = document.createElement("canvas"); tmp.width = W; tmp.height = H;
  tmp.getContext("2d").putImageData(src, 0, 0);
  for (let i = 0; i < bands; i++) {
    const y = Math.floor(r() * H), h = Math.floor(2 + r() * (H / 18));
    const dx = Math.floor((r() - 0.5) * amount * 80);
    ctx.drawImage(tmp, 0, y, W, h, dx, y, W, h);
  }
  // RGB channel split
  ctx.globalCompositeOperation = "lighter";
  const off = Math.round(amount * 10);
  ctx.globalAlpha = 0.5;
  ctx.drawImage(tmp, -off, 0); ctx.drawImage(tmp, off, 0);
  ctx.globalAlpha = 1; ctx.globalCompositeOperation = "source-over";
};

const bigText = (ctx, W, H, text, color, y, size) => {
  ctx.save();
  ctx.font = `900 ${size}px 'Arial Black', Impact, sans-serif`;
  ctx.textAlign = "center"; ctx.lineWidth = size * 0.09; ctx.strokeStyle = "#000";
  ctx.fillStyle = color; ctx.strokeText(text, W / 2, y); ctx.fillText(text, W / 2, y);
  ctx.restore();
};

const redactBars = (ctx, W, H, amount) => {
  const r = rand(77); const n = Math.round(2 + amount * 5);
  ctx.fillStyle = "#000";
  for (let i = 0; i < n; i++) {
    const bw = W * (0.2 + r() * 0.45), bh = H * (0.04 + r() * 0.05);
    ctx.fillRect(r() * (W - bw), r() * (H - bh), bw, bh);
  }
};

const brokenChart = (ctx, W, H, amount) => {
  ctx.save(); ctx.strokeStyle = "#FF3366"; ctx.lineWidth = Math.max(4, W * 0.008);
  ctx.beginPath(); const steps = 8; let x = W * 0.1, y = H * 0.35;
  ctx.moveTo(x, y);
  for (let i = 0; i < steps; i++) { x += (W * 0.8) / steps; y += (H * 0.5) / steps + (i % 2 ? -H * 0.05 : H * 0.02); ctx.lineTo(x, Math.min(y, H * 0.92)); }
  ctx.stroke();
  ctx.fillStyle = "#FF3366"; ctx.font = `900 ${W * 0.06}px 'Arial Black'`; ctx.fillText("↓", W * 0.85, H * 0.9);
  ctx.restore();
};

const goldWash = (ctx, W, H, amount) => {
  const g = ctx.createLinearGradient(0, 0, W, H);
  g.addColorStop(0, `rgba(255,215,0,${0.12 + amount * 0.25})`);
  g.addColorStop(0.5, "rgba(255,255,255,0.05)");
  g.addColorStop(1, `rgba(184,134,11,${0.12 + amount * 0.25})`);
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
};

const robbedBorder = (ctx, W, H, color = "#00FF66") => {
  ctx.lineWidth = Math.max(10, W * 0.02); ctx.strokeStyle = "#000"; ctx.strokeRect(0, 0, W, H);
  ctx.lineWidth = Math.max(6, W * 0.012); ctx.strokeStyle = color;
  const p = W * 0.02; ctx.strokeRect(p, p, W - 2 * p, H - 2 * p);
};

export const REMIX_STYLES = [
  {
    id: "rugged", name: "RUGGED", tagline: "Glitched, degraded, redacted.",
    defaults: { brightness: 90, contrast: 130, saturation: 80, glitch: 0.6 },
    overlay: (ctx, W, H, o) => {
      drawGlitch(ctx, W, H, o.glitch);
      redactBars(ctx, W, H, o.glitch);
      if (o.showLabel) bigText(ctx, W, H, "RUGGED", "#FF3366", H * 0.55, W * 0.14);
    },
  },
  {
    id: "degen", name: "DEGEN", tagline: "High-contrast crypto chaos.",
    defaults: { brightness: 105, contrast: 160, saturation: 160, glitch: 0.35 },
    overlay: (ctx, W, H, o) => {
      drawGlitch(ctx, W, H, o.glitch);
      ctx.save(); ctx.globalAlpha = 0.5; ctx.fillStyle = "#A855F7"; ctx.globalCompositeOperation = "overlay";
      ctx.fillRect(0, 0, W, H); ctx.restore();
      if (o.showLabel) bigText(ctx, W, H, "DEGEN", "#00FF66", H * 0.9, W * 0.16);
    },
  },
  {
    id: "rich", name: "THEY GOT RICH", tagline: "Premium gold treatment.",
    defaults: { brightness: 110, contrast: 115, saturation: 120, glitch: 0 },
    overlay: (ctx, W, H, o) => {
      goldWash(ctx, W, H, 0.5);
      if (o.showLabel) bigText(ctx, W, H, "THEY GOT RICH", "#FFD700", H * 0.88, W * 0.085);
    },
  },
  {
    id: "robbed", name: "WE GOT ROBBED", tagline: "Broken charts & glitch.",
    defaults: { brightness: 85, contrast: 125, saturation: 70, glitch: 0.5 },
    overlay: (ctx, W, H, o) => {
      drawGlitch(ctx, W, H, o.glitch);
      brokenChart(ctx, W, H, o.glitch);
      if (o.showLabel) bigText(ctx, W, H, "WE GOT ROBBED", "#FF3366", H * 0.9, W * 0.085);
    },
  },
  {
    id: "classic", name: "CLASSIC ROBBED", tagline: "Clean border & branding.",
    defaults: { brightness: 100, contrast: 105, saturation: 105, glitch: 0 },
    overlay: (ctx, W, H, o) => { /* border+branding handled by main renderer */ },
  },
];

export const getStyle = (id) => REMIX_STYLES.find((s) => s.id === id) || REMIX_STYLES[0];

// Main render: draws image (fit), applies filters + style overlay + optional border/branding/caption.
export function renderRemix(canvas, img, style, o, handle = "@robbedcoin") {
  const MAX = 1080;
  let W = img.naturalWidth || img.width, H = img.naturalHeight || img.height;
  const scale = Math.min(1, MAX / Math.max(W, H));
  W = Math.max(1, Math.round(W * scale)); H = Math.max(1, Math.round(H * scale));
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  ctx.filter = `brightness(${o.brightness}%) contrast(${o.contrast}%) saturate(${o.saturation}%)`;
  ctx.drawImage(img, 0, 0, W, H);
  ctx.filter = "none";
  try { style.overlay(ctx, W, H, o); } catch (e) { /* keep image */ }

  if (o.caption) {
    const fs = Math.max(20, W * 0.06);
    ctx.font = `900 ${fs}px 'Arial Black', Impact, sans-serif`;
    ctx.textAlign = "center"; ctx.lineWidth = fs * 0.12; ctx.strokeStyle = "#000"; ctx.fillStyle = "#fff";
    const y = H - fs * 0.7;
    ctx.strokeText(o.caption.toUpperCase(), W / 2, y); ctx.fillText(o.caption.toUpperCase(), W / 2, y);
  }
  if (o.branding) {
    const fs = Math.max(16, W * 0.035);
    ctx.font = `900 ${fs}px 'Arial Black', Impact, sans-serif`;
    ctx.textAlign = "right"; ctx.textBaseline = "bottom";
    ctx.shadowColor = "rgba(0,0,0,0.5)"; ctx.shadowBlur = fs * 0.2;
    ctx.fillStyle = "#00FF66"; ctx.fillText("$ROBBED", W - W * 0.03, H - W * 0.03 - fs * 1.1);
    ctx.fillStyle = "rgba(245,245,240,0.85)"; ctx.font = `700 ${fs * 0.6}px 'Arial Black', sans-serif`;
    ctx.fillText(handle, W - W * 0.03, H - W * 0.03);
    ctx.shadowColor = "transparent"; ctx.shadowBlur = 0; ctx.textBaseline = "alphabetic";
  }
  if (o.border || style.id === "classic") robbedBorder(ctx, W, H, style.id === "rich" ? "#FFD700" : "#00FF66");
}
